import React, { useState, useEffect, createContext } from 'react';
import ChatbotApiClient from '../../methods/api/chatbotapiClient';
import { useSelector } from 'react-redux';
import loader from '../../methods/loader';

// Create a context
const ChatbotContext = createContext();


// Create a provider component
const ChatbotProvider = ({ children }) => {

  const user = useSelector((state) => state.user);

  const [chatbotData, setChatbotData] = useState({});
  const [chatbotAppearanceData, setChatbotAppearanceData] = useState({});
// Your API call to fetch chatbot data 
    const fetchData = async () => {
      try {
        if (!(user?.mainUserId)) {
          return
        } 
      } catch (error) {
      }
    };
 

  useEffect(() => {
    

    fetchData();
  }, []);




  return (
    // Wrap your component tree with the context provider
    <ChatbotContext.Provider value={{ chatbotData, setChatbotData, chatbotAppearanceData,fetchData, setChatbotAppearanceData }}>
      {children}
    </ChatbotContext.Provider>
  );
};

export { ChatbotProvider, ChatbotContext };